import { FormField } from 'src/common/FormField';
import { FormFieldController } from 'src/common/FormField/FormFieldController';

export function WillCallContextField({ fieldPath }: { fieldPath: string }) {
  return (
    <FormFieldController name={`${fieldPath}.is_will_call`}>
      {({ field, fieldState }) => {
        return (
          <FormField
            label={'Is this leg will call?'}
            error={fieldState.error?.message?.toString()}
            inputProps={{
              id: `${fieldPath}.is_will_call`,
              ...field,
              onChange: field.onChange,
            }}
            type="switch"
          />
        );
      }}
    </FormFieldController>
  );
}
